import type { Reference } from "../data/types";
import ReferenceCard from "./ReferenceCard";

interface ReferencesPanelProps {
  references: Reference[];
}

export default function ReferencesPanel({ references }: ReferencesPanelProps) {
  if (references.length === 0) return null;

  return (
    <div>
      <h3 className="ghw-text-xs ghw-font-medium ghw-text-muted-foreground ghw-mb-2">
        Based on {references.length} source{references.length !== 1 ? "s" : ""}
      </h3>
      <div className="ghw-space-y-1">
        {references.map((ref, i) => (
          <ReferenceCard key={ref.permalink} reference={ref} index={i} />
        ))}
      </div>
    </div>
  );
}
